<template>
  <div>
    <h4 class="form-title">Общие сведения</h4>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <validation-provider
          ref="commisionNumber"
          :name="'№ поручения'"
          :rules="{ required: true, max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-1"
            label="№ поручения"
            label-for="input-1"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!commissionForm.DocumentNumber), 'empty-field': !(!!commissionForm.DocumentNumber) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-1"
              :class="{ 'form-input': true, 'filled-field': (!!commissionForm.DocumentNumber), 'required-field': !(!!commissionForm.DocumentNumber) }"
              v-model="commissionForm.DocumentNumber"
              placeholder="№ поручения"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-datepicker
          ref="DocumentDate"
          inputId="DocumentDate"
          inputName="Дата поручения"
          :disabled="notForEdit"
          :required="true"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/, required: true }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="BorderCustomCode"
          inputId="BorderCustomCode"
          inputName="Код таможенного органа"
          :inputValidationRules="{ required: true, max: 8,  regex: /^\d+$/ }"
          :inputItems="nsiAuthorities"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование ТО' }
          ]"
          :inputRelatedFields="[
            { BorderCustomCode: 'code' },
            { BorderCustomsOfficeName: 'name' }
          ]"
          :required="true"
          :getData="loadNsiAuthorities"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="code"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="BorderCustomsOfficeName"
          inputId="BorderCustomsOfficeName"
          inputName="Наименование таможенного органа"
          :inputValidationRules="{ max: 50 }"
          :inputItems="nsiAuthorities"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование ТО' }
          ]"
          :inputRelatedFields="[
            { BorderCustomCode: 'code' },
            { BorderCustomsOfficeName: 'name' }
          ]"
          :getData="loadNsiAuthorities"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <h4 class="form-title">Перевозчик</h4>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="carrierName"
          :name="'Наименование перевозчика'"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-5"
            label="Наименование перевозчика"
            label-for="input-5"
            :label-class="(!!commissionForm.Carrier_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-5"
              :class="(!!commissionForm.Carrier_Name) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.Carrier_Name"
              placeholder="Наименование перевозчика"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Carrier_CountryName"
          inputId="Carrier_CountryName"
          inputName="Наименование страны перевозчика"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Carrier_CountryCode: 'abc2' },
            { Carrier_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Carrier_CountryCode"
          inputId="Carrier_CountryCode"
          inputName="Буквенный код страны перевозчика"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Carrier_CountryCode: 'abc2' },
            { Carrier_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-right">
        <b-button class="collapsed" @click="collapseCarrierVisible = !collapseCarrierVisible" variant="link">Уточнить адрес</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-carrier" v-model="collapseCarrierVisible">
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="carrierINN"
            :name="'ИНН перевозчика'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-8"
              label="ИНН"
              label-for="input-8"
              :label-class="(!!commissionForm.Carrier_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-8"
                :class="(!!commissionForm.Carrier_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="carrierKPP"
            :name="'КПП перевозчика'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-9"
              label="КПП"
              label-for="input-9"
              :label-class="(!!commissionForm.Carrier_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-9"
                :class="(!!commissionForm.Carrier_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="carrierOGRN"
            :name="'ОГРН перевозчика'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-10"
              label="ОГРН"
              label-for="input-10"
              :label-class="(!!commissionForm.Carrier_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-10"
                :class="(!!commissionForm.Carrier_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="carrierPostalCode"
            :name="'Индекс перевозчика'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-11"
              label="Почтовый индекс"
              label-for="input-11"
              :label-class="(!!commissionForm.Carrier_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-11"
                :class="(!!commissionForm.Carrier_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="carrierRegion"
            :name="'Область (регион, штат, провинция и т.п.) перевозчика'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-12"
              label="Область (регион, штат, провинция и т.п.)"
              label-for="input-12"
              :label-class="(!!commissionForm.Carrier_Region) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-12"
                :class="(!!commissionForm.Carrier_Region) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_Region"
                placeholder="Область (регион, штат, провинция и т.п.)"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="carrierCity"
            :name="'Населенный пункт перевозчика'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-13"
              label="Населенный пункт"
              label-for="input-13"
              :label-class="(!!commissionForm.Carrier_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-13"
                :class="(!!commissionForm.Carrier_City) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="carrierStreetHouse"
            :name="'Улица, номер дома, номер офиса перевозчика'"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-14"
              label="Улица, номер дома, номер офиса"
              label-for="input-14"
              :label-class="(!!commissionForm.Carrier_StreetHouse) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-14"
                :class="(!!commissionForm.Carrier_StreetHouse) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Carrier_StreetHouse"
                placeholder="Улица, номер дома, номер офиса"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-collapse>
    <h4 class="form-title">Отправитель</h4>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="consignorName"
          :name="'Наименование отправителя'"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование отправителя"
            label-for="input-15"
            :label-class="(!!commissionForm.Consignor_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="(!!commissionForm.Consignor_Name) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.Consignor_Name"
              placeholder="Наименование отправителя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Consignor_CountryName"
          inputId="Consignor_CountryName"
          inputName="Наименование страны отправителя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Consignor_CountryCode"
          inputId="Consignor_CountryCode"
          inputName="Буквенный код страны отправителя"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-right">
        <b-button class="collapsed" @click="collapseConsignorVisible = !collapseConsignorVisible" variant="link">Уточнить адрес</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-consignor" v-model="collapseConsignorVisible">
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorINN"
            :name="'ИНН отправителя'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-18"
              label="ИНН"
              label-for="input-18"
              :label-class="(!!commissionForm.Consignor_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-18"
                :class="(!!commissionForm.Consignor_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorKPP"
            :name="'КПП отправителя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-19"
              label="КПП"
              label-for="input-19"
              :label-class="(!!commissionForm.Consignor_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-19"
                :class="(!!commissionForm.Consignor_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorOGRN"
            :name="'ОГРН отправителя'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-20"
              label="ОГРН"
              label-for="input-20"
              :label-class="(!!commissionForm.Consignor_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-20"
                :class="(!!commissionForm.Consignor_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorPostalCode"
            :name="'Индекс отправителя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-21"
              label="Почтовый индекс"
              label-for="input-21"
              :label-class="(!!commissionForm.Consignor_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-21"
                class="form-input"
                :class="(!!commissionForm.Consignor_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="consignorRegion"
            :name="'Область (регион, штат, провинция и т.п.) отправителя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-22"
              label="Область (регион, штат, провинция и т.п.)"
              label-for="input-22"
              :label-class="(!!commissionForm.Consignor_Region) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-22"
                :class="(!!commissionForm.Consignor_Region) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_Region"
                placeholder="Область (регион, штат, провинция и т.п.)"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorCity"
            :name="'Населенный пункт отправителя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-23"
              label="Населенный пункт"
              label-for="input-23"
              :label-class="(!!commissionForm.Consignor_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-23"
                :class="(!!commissionForm.Consignor_City) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="consignorStreetHouse"
            :name="'Улица, номер дома, номер офиса отправителя'"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-24"
              label="Улица, номер дома, номер офиса"
              label-for="input-24"
              :label-class="(!!commissionForm.Consignor_StreetHouse) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-24"
                :class="(!!commissionForm.Consignor_StreetHouse) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignor_StreetHouse"
                placeholder="Улица, номер дома, номер офиса"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-collapse>
    <h4 class="form-title">Получатель</h4>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="consigneeName"
          :name="'Наименование получателя'"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-25"
            label="Наименование получателя"
            label-for="input-25"
            :label-class="(!!commissionForm.Consignee_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-25"
              :class="(!!commissionForm.Consignee_Name) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.Consignee_Name"
              placeholder="Наименование получателя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Consignee_CountryName"
          inputId="Consignee_CountryName"
          inputName="Наименование страны получателя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Consignee_CountryCode"
          inputId="Consignee_CountryCode"
          inputName="Буквенный код страны получателя"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-right">
        <b-button class="collapsed" @click="collapseConsigneeVisible = !collapseConsigneeVisible" variant="link">Уточнить адрес</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-consignee" v-model="collapseConsigneeVisible">
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneeINN"
            :name="'ИНН получателя'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="ИНН"
              label-for="input-28"
              :label-class="(!!commissionForm.Consignee_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!commissionForm.Consignee_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneeKPP"
            :name="'КПП получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-29"
              label="КПП"
              label-for="input-29"
              :label-class="(!!commissionForm.Consignee_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-29"
                :class="(!!commissionForm.Consignee_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneeOGRN"
            :name="'ОГРН получателя'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-30"
              label="ОГРН"
              label-for="input-30"
              :label-class="(!!commissionForm.Consignee_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-30"
                :class="(!!commissionForm.Consignee_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneePostalCode"
            :name="'Индекс получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-31"
              label="Почтовый индекс"
              label-for="input-31"
              :label-class="(!!commissionForm.Consignee_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-31"
                :class="(!!commissionForm.Consignee_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="consigneeRegion"
            :name="'Область (регион, штат, провинция и т.п.) получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-32"
              label="Область (регион, штат, провинция и т.п.)"
              label-for="input-32"
              :label-class="(!!commissionForm.Consignee_Region) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-32"
                :class="(!!commissionForm.Consignee_Region) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_Region"
                placeholder="Область (регион, штат, провинция и т.п.)"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneeCity"
            :name="'Населенный пункт получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-33"
              label="Населенный пункт"
              label-for="input-33"
              :label-class="(!!commissionForm.Consignee_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-33"
                :class="(!!commissionForm.Consignee_City) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="consigneeStreetHouse"
            :name="'Улица, номер дома, номер офиса получателя'"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-34"
              label="Улица, номер дома, номер офиса"
              label-for="input-34"
              :label-class="(!!commissionForm.Consignee_StreetHouse) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-34"
                :class="(!!commissionForm.Consignee_StreetHouse) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Consignee_StreetHouse"
                placeholder="Улица, номер дома, номер офиса"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-collapse>
    <h4 class="form-title">Уведомить</h4>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="notifyName"
          :name="'Наименование'"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-35"
            label="Наименование"
            label-for="input-35"
            :label-class="(!!commissionForm.Notify_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-35"
              :class="(!!commissionForm.Notify_Name) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.Notify_Name"
              placeholder="Наименование"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Notify_CountryName"
          inputId="Notify_CountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Notify_CountryCode: 'abc2' },
            { Notify_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="Notify_CountryCode"
          inputId="Notify_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Notify_CountryCode: 'abc2' },
            { Notify_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-right">
        <b-button class="collapsed" @click="collapseNotifyVisible = !collapseNotifyVisible" variant="link">Уточнить адрес</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-notify" v-model="collapseNotifyVisible">
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="notifyINN"
            :name="'ИНН'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-38"
              label="ИНН"
              label-for="input-38"
              :label-class="(!!commissionForm.Notify_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-38"
                :class="(!!commissionForm.Notify_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="notifyKPP"
            :name="'КПП'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-39"
              label="КПП"
              label-for="input-39"
              :label-class="(!!commissionForm.Notify_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-39"
                :class="(!!commissionForm.Notify_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="notifyOGRN"
            :name="'ОГРН'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-40"
              label="ОГРН"
              label-for="input-40"
              :label-class="(!!commissionForm.Notify_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-40"
                :class="(!!commissionForm.Notify_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="notifyPostalCode"
            :name="'Индекс'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-41"
              label="Почтовый индекс"
              label-for="input-41"
              :label-class="(!!commissionForm.Notify_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-41"
                :class="(!!commissionForm.Notify_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="notifyRegion"
            :name="'Область (регион, штат, провинция и т.п.)'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-42"
              label="Область (регион, штат, провинция и т.п.)"
              label-for="input-42"
              :label-class="(!!commissionForm.Notify_Region) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-42"
                :class="(!!commissionForm.Notify_Region) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_Region"
                placeholder="Область (регион, штат, провинция и т.п.)"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="notifyCity"
            :name="'Населенный пункт'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-43"
              label="Населенный пункт"
              label-for="input-43"
              :label-class="(!!commissionForm.Notify_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-43"
                :class="(!!commissionForm.Notify_City) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <validation-provider
            ref="notifyStreetHouse"
            :name="'Улица, номер дома, номер офиса'"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-44"
              label="Улица, номер дома, номер офиса"
              label-for="input-44"
              :label-class="(!!commissionForm.Notify_StreetHouse) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-44"
                :class="(!!commissionForm.Notify_StreetHouse) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Notify_StreetHouse"
                placeholder="Улица, номер дома, номер офиса"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="lineName"
          :name="'Контейнерная линия'"
          :rules="{ max: 50 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-45"
            label="Контейнерная линия"
            label-for="input-45"
            :label-class="(!!commissionForm.Line_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-45"
              :class="(!!commissionForm.Line_Name) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.Line_Name"
              placeholder="Контейнерная линия"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-title">Судно</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="vesselName"
          :name="'Наименование судна'"
          :rules="{ max: 150, required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-46"
            label="Наименование судна"
            label-for="input-46"
            :label-class="(!!commissionForm.VesselName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-46"
              :class="{ 'form-input': true, 'filled-field': (!!commissionForm.VesselName), 'required-field': !(!!commissionForm.VesselName) }"
              v-model="commissionForm.VesselName"
              placeholder="Наименование судна"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="3" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="vesselIMO"
          :name="'ИМО судна'"
          :rules="{ max: 7, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-47"
            label="ИМО судна"
            label-for="input-47"
            :label-class="(!!commissionForm.IMO) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-47"
              :class="(!!commissionForm.IMO) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.IMO"
              placeholder="ИМО судна"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="3" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="vesselShipmaster"
          :name="'Фамилия капитана судна'"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-48"
            label="Фамилия капитана судна"
            label-for="input-48"
            :label-class="(!!commissionForm.VesselShipmaster) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-48"
              :class="(!!commissionForm.VesselShipmaster) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.VesselShipmaster"
              placeholder="Фамилия капитана судна"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="VesselNationality"
          inputId="VesselNationality"
          inputName="Наименование страны перевозчика"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { VesselNationalityCode: 'abc2' },
            { VesselNationality: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="VesselNationalityCode"
          inputId="VesselNationalityCode"
          inputName="Буквенный код страны принадлежности судна"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { VesselNationalityCode: 'abc2' },
            { VesselNationality: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <validation-provider
          ref="vesselCruise"
          :name="'Номер рейса'"
          :rules="{ max: 10 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-51"
            label="Номер рейса"
            label-for="input-51"
            :label-class="(!!commissionForm.Cruise) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-51"
              :class="(!!commissionForm.Cruise) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.Cruise"
              placeholder="Номер рейса"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <validation-provider
          ref="vesselRegNumBook"
          :name="'Booking №'"
          :rules="{ max: 50 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-52"
            label="Booking №"
            label-for="input-52"
            :label-class="(!!commissionForm.RegNumBook) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-52"
              :class="(!!commissionForm.RegNumBook) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.RegNumBook"
              placeholder="Booking №"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="LoadingName"
          inputId="LoadingName"
          inputName="Название порта погрузки"
          :inputValidationRules="{ max: 50, required: true }"
          :inputItems="nsiPorts"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'port_code', label: 'Код' },
            { key: 'port_eng', label: 'Port' },
            { key: 'port_rus', label: 'Порт' },
          ]"
          :inputRelatedFields="[
            { LoadingCode: 'port_code' },
            { LoadingName: `${portLang}`  }
          ]"
          :getData="loadNsiPorts"
          :disabled="notForEdit"
          :required="true"
          :delay="2"
          query="port_name"
          :select="portLang"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="LoadingCode"
          inputId="LoadingCode"
          inputName="Код порта погрузки"
          :inputValidationRules="{ max: 5, regex: /^[a-zA-Z]{2}[a-zA-Z0-9]{3}$/ }"
          :inputItems="nsiPorts"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'port_code', label: 'Код' },
            { key: 'port_eng', label: 'Port' },
            { key: 'port_rus', label: 'Порт' },
          ]"
          :inputRelatedFields="[
            { LoadingCode: 'port_code' },
            { LoadingName: `${portLang}`  }
          ]"
          :getData="loadNsiPorts"
          :disabled="notForEdit"
          :delay="1"
          query="port_code"
          select="port_code"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="UnloadingName"
          inputId="UnloadingName"
          inputName="Название порта выгрузки"
          :inputValidationRules="{ max: 50, required: true }"
          :inputItems="nsiPorts"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'port_code', label: 'Код' },
            { key: 'port_eng', label: 'Port' },
            { key: 'port_rus', label: 'Порт' },
          ]"
          :inputRelatedFields="[
            { UnloadingCode: 'port_code' },
            { UnloadingName: `${portLang}`  }
          ]"
          :getData="loadNsiPorts"
          :disabled="notForEdit"
          :required="true"
          :delay="2"
          query="port_name"
          :select="portLang"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-input
          ref="UnloadingCode"
          inputId="UnloadingCode"
          inputName="Код порта выгрузки"
          :inputValidationRules="{ max: 5, regex: /^[a-zA-Z]{2}[a-zA-Z0-9]{3}$/ }"
          :inputItems="nsiPorts"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'port_code', label: 'Код' },
            { key: 'port_eng', label: 'Port' },
            { key: 'port_rus', label: 'Порт' },
          ]"
          :inputRelatedFields="[
            { UnloadingCode: 'port_code' },
            { UnloadingName: `${portLang}`  }
          ]"
          :getData="loadNsiPorts"
          :disabled="notForEdit"
          :delay="2"
          query="port_code"
          select="port_code"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <h4 class="form-title">Поручение подготовил</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="DocSigPersonName"
          :name="'ФИО'"
          :rules="{ max: 150, required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-57"
            label="ФИО"
            label-for="input-57"
            :label-class="(!!commissionForm.DocSig_PersonName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-57"
              :class="{ 'form-input': true, 'filled-field': (!!commissionForm.DocSig_PersonName), 'required-field': !(!!commissionForm.DocSig_PersonName) }"
              v-model="commissionForm.DocSig_PersonName"
              placeholder="ФИО"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="3" lg="4" md="4" sm="4" cols="12">
        <custom-datepicker
          ref="DocSig_IssueDate"
          inputId="DocSig_IssueDate"
          inputName="Дата"
          :disabled="notForEdit"
          :required="true"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/, required: true }"
          @setForm="setModel($event)"
        ></custom-datepicker>
      </b-col>
      <b-col xl="3" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="DocSigPhone"
          :name="'Телефон'"
          :rules="{ max: 24 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-59"
            label="Телефон"
            label-for="input-59"
            :label-class="(!!commissionForm.DocSig_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-59"
              :class="(!!commissionForm.DocSig_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="commissionForm.DocSig_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-left">
        <b-button class="collapsed" @click="collapseForwarderVisible = !collapseForwarderVisible" variant="link">Экспедитор (необязательно)</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-forwarder" v-model="collapseForwarderVisible" class="pt-3">
      <b-row>
        <b-col xl="8" lg="12" md="12" sm="12" cols="12">
          <validation-provider
            ref="Forwarder"
            :name="'Наименование экспедитора'"
            :rules="{ max: 150 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-60"
              label="Наименование экспедитора"
              label-for="input-60"
              :label-class="(!!commissionForm.Forwarder) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-60"
                :class="(!!commissionForm.Forwarder) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.Forwarder"
                placeholder="Наименование экспедитора"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="8" lg="12" md="12" sm="12" cols="12">
          <custom-input
            ref="FrDescription"
            inputId="FrDescription"
            inputName="Примечание экспедитора"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 5000 }"
            :edited="true"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
      <h4 class="form-title-forwarder">Разрешительные документы экспедитора</h4>
      <b-row v-for="(item, index) in commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM" :key="index">
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            :ref="'DocumentName-' + index"
            :name="'Разрешительные документы: Наименование-' + index"
            :rules="{ max: 250 }"
            v-slot="validationContext">
            <b-form-group
              :id="'input-group-62-' + index"
              label="Наименование"
              :label-for="'input-62-' + index"
              :label-class="(!!item.DocumentName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                :id="'input-62-' + index"
                :class="(!!item.DocumentName) ? 'form-input filled-field' : 'form-input'"
                v-model="item.DocumentName"
                placeholder="Наименование"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            :ref="'DocumentNumber-' + index"
            :name="'Разрешительные документы: Номер-' + index"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              :id="'input-group-63-' + index"
              label="Номер"
              :label-for="'input-63-' + index"
              :label-class="(!!item.DocumentNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                :id="'input-63-' + index"
                :class="(!!item.DocumentNumber) ? 'form-input filled-field' : 'form-input'"
                v-model="item.DocumentNumber"
                placeholder="Номер"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <div class="d-flex align-items-start">
            <custom-datepicker
              class="w-100"
              :ref="'DocumentDate-' + index"
              :inputId="'DocumentDate-' + index"
              :inputName="'Разрешительные документы: Дата-' + index"
              :index="index"
              :disabled="notForEdit"
              parent="FWDOCUMENT_ITEM"
              customPlaceholder="Дата"
              :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
              @setForm="setModel($event)"
            ></custom-datepicker>
            <b-button :disabled="notForEdit" @click="removePermissiveDocuments(index)" :class="{ 'ml-3': true, 'mr-3': index === (commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.length - 1) }" squared size="sm" variant="outline-secondary">
              <font-awesome-icon icon="fa-solid fa-minus" />
            </b-button>
            <b-button :disabled="notForEdit" v-if="index === (commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.length - 1)" @click="addPermissiveDocuments" squared size="sm" variant="outline-success">
              <font-awesome-icon icon="fa-solid fa-plus" />
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mt-2">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-left">
        <b-button class="collapsed" @click="collapseContractVisible = !collapseContractVisible" variant="link">Контракт (необязательно)</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-contract" v-model="collapseContractVisible" class="pt-3">
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="ContractName"
            :name="'Контракт: Наименование'"
            :rules="{ max: 250 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-65"
              label="Наименование"
              label-for="input-65"
              :label-class="(!!commissionForm.ContractName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-65"
                :class="(!!commissionForm.ContractName) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.ContractName"
                placeholder="Наименование"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="ContractNumber"
            :name="'Контракт: Номер'"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-66"
              label="Номер"
              label-for="input-66"
              :label-class="(!!commissionForm.ContractNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-66"
                :class="(!!commissionForm.ContractNumber) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.ContractNumber"
                placeholder="Номер"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <custom-datepicker
            ref="ContractDate"
            inputId="ContractDate"
            inputName="Дата"
            :disabled="notForEdit"
            :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
            @setForm="setModel($event)"
            @updateIdbData="updateIdbData"
          ></custom-datepicker>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mt-2">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-left">
        <b-button class="collapsed" @click="collapseDeliveryVisible = !collapseDeliveryVisible" variant="link">Условия поставки (необязательно)</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-delivery" v-model="collapseDeliveryVisible" class="pt-3">
      <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <custom-input
            ref="DeliveryTermsStringCode"
            inputId="DeliveryTermsStringCode"
            inputName="Код условий поставки"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 3 }"
            :inputItems="nsiDeliveryCodes"
            :targetInput="targetInput"
            :inputFields="[
              { key: 'code_eng', label: 'Код' },
              { key: 'description', label: 'Описание' }
            ]"
            :loadOnFocus="true"
            :getData="loadNsiDeliveryCodes"
            select="code_eng"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="DeliveryPlace"
            :name="'Наименование пункта поставки'"
            :rules="{ max: 250 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-69"
              label="Наименование пункта поставки"
              label-for="input-69"
              :label-class="(!!commissionForm.DeliveryPlace) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-69"
                :class="(!!commissionForm.DeliveryPlace) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.DeliveryPlace"
                placeholder="Наименование пункта поставки"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="TransferPlace"
            :name="'Место передачи товара'"
            :rules="{ max: 250 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-70"
              label="Место передачи товара"
              label-for="input-70"
              :label-class="(!!commissionForm.TransferPlace) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-70"
                :class="(!!commissionForm.TransferPlace) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.TransferPlace"
                placeholder="Место передачи товара"
                :state="getValidationState(validationContext)"
                :disabled="notForEdit"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mt-2">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-left">
        <b-button class="collapsed" @click="collapseReloadVisible = !collapseReloadVisible" variant="link">Информация о перегрузке (необязательно)</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-overload" v-model="collapseReloadVisible" class="pt-3">
      <b-row>
        <b-col xl="8" lg="12" md="12" sm="12" cols="12">
          <custom-input
            ref="Reload"
            inputId="Reload"
            inputName="Информация о перегрузке"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 5000 }"
            :edited="true"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mt-2">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="text-left">
        <b-button class="collapsed" @click="collapseDocumentVisible = !collapseDocumentVisible" variant="link">Предоставляемый документ (необязательно)</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-document" v-model="collapseDocumentVisible" class="pt-3">
      <b-row>
        <b-col xl="4" lg="6" md="6" sm="6" cols="12">
          <custom-input
            ref="ACCOMPANYINGDOCUMENT_DocumentKind"
            inputId="ACCOMPANYINGDOCUMENT_DocumentKind"
            inputName="Тип предоставляемого документа"
            :inputValidationRules="{}"
            :inputItems="DocumentKindOptions"
            :targetInput="targetInput"
            :disabled="notForEdit"
            :inputFields="[{ key: 'text', label: 'Тип' }]"
            :loadOnFocus="true"
            :getData="() => { return promise.resolve() }"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
        <b-col xl="4" lg="6" md="6" sm="6" cols="12">
          <validation-provider
            ref="ACCOMPANYINGDOCUMENT_DocumentName"
            :name="'Наименование предоставляемого документа'"
            :rules="{ max: 250 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-73"
              label="Наименование предоставляемого документа"
              label-for="input-73"
              :label-class="(!!commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-73"
                :class="(!!commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentName) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentName"
                placeholder="Наименование"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="6" md="6" sm="6" cols="12">
          <validation-provider
            ref="ACCOMPANYINGDOCUMENT_DocumentNumber"
            :name="'Номер предоставляемого документа'"
            :rules="{ max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-74"
              label="Номер предоставляемого документа"
              label-for="input-74"
              :label-class="(!!commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-74"
                :class="(!!commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentNumber) ? 'form-input filled-field' : 'form-input'"
                v-model="commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentNumber"
                placeholder="Номер"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="6" md="6" sm="6" cols="12">
          <custom-datepicker
            ref="ACCOMPANYINGDOCUMENT_DocumentDate"
            inputId="ACCOMPANYINGDOCUMENT_DocumentDate"
            inputName="Дата"
            :disabled="notForEdit"
            :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
            @setForm="setModel($event)"
            @updateIdbData="updateIdbData"
          ></custom-datepicker>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CustomInput from '../../CustomInput'
  import CustomDatepicker from '../../CustomDatepicker'
  import moment from 'moment'
  export default {
    name: "CommissionPage",
    props: ['getValidationState', 'commissionShipmentDoc', 'notForEdit', 'targetInput'],
    components: {
      CustomInput,
      CustomDatepicker
    },
    data () {
      return {
        promise: window.Promise,
        commissionForm: {
          did: null,
          DocumentNumber: null, // № поручения
          DocumentDate: null, // Дата поручения
          BorderCustomCode: null, // Код таможенного органа
          BorderCustomsOfficeName: null, // Наименование таможенного органа
          Carrier_Name: null, // Перевозчик: наименование
          Carrier_INN: null, // Перевозчик: ИНН
          Carrier_KPP: null, // Перевозчик: КПП
          Carrier_OGRN: null, // Перевозчик: ОГРН
          Carrier_PostalCode: null, // Перевозчик: почтовый индекс
          Carrier_CountryCode: null, // Перевозчик: буквенный код страны
          Carrier_CountryName: null, // Перевозчик: наименование страны
          Carrier_Region: null, // Перевозчик: область (регион, штат, провинция и т.п.)
          Carrier_City: null, // Перевозчик: населенный пункт
          Carrier_StreetHouse: null, // Перевозчик: улица, номер дома, номер офиса
          Consignor_Name: null, // Отправитель: наименование
          Consignor_INN: null, // Отправитель: ИНН
          Consignor_KPP: null, // Отправитель: КПП
          Consignor_OGRN: null, // Отправитель: ОГРН
          Consignor_PostalCode: null, // Отправитель: почтовый индекс
          Consignor_CountryCode: null, // Отправитель: буквенный код страны
          Consignor_CountryName: null, // Отправитель: наименование страны
          Consignor_Region: null, // Отправитель: область (регион, штат, провинция и т.п.)
          Consignor_City: null, // Отправитель: населенный пункт
          Consignor_StreetHouse: null, // Отправитель: улица, номер дома, номер офиса
          Consignee_Name: null, // Получатель: наименование
          Consignee_INN: null, // Получатель: ИНН
          Consignee_KPP: null, // Получатель: КПП
          Consignee_OGRN: null, // Получатель: ОГРН
          Consignee_PostalCode: null, // Получатель: почтовый индекс
          Consignee_CountryCode: null, // Получатель: буквенный код страны
          Consignee_CountryName: null, // Получатель: наименование страны
          Consignee_Region: null, // Получатель: область (регион, штат, провинция и т.п.)
          Consignee_City: null, // Получатель: населенный пункт
          Consignee_StreetHouse: null, // Получатель: улица, номер дома, номер офиса
          Notify_Name: null, // Уведомить: наименование
          Notify_INN: null, // Уведомить: ИНН
          Notify_KPP: null, // Уведомить: КПП
          Notify_OGRN: null, // Уведомить: ОГРН
          Notify_PostalCode: null, // Уведомить: почтовый индекс
          Notify_CountryCode: null, // Уведомить: буквенный код страны
          Notify_CountryName: null, // Уведомить: наименование страны
          Notify_Region: null, // Уведомить: область (регион, штат, провинция и т.п.)
          Notify_City: null, // Уведомить: населенный пункт
          Notify_StreetHouse: null, // Уведомить: улица, номер дома, номер офиса
          Line_Name: null, // Наименование линии
          VesselName: null, // Наименование судна
          VesselShipmaster: null, // Фамилия капитана судна
          IMO: null, // ИМО судна
          Cruise: null, // Номер рейса
          LoadingName: null, // Погрузка груза: название порта
          LoadingCode: null, // Погрузка груза: код порта
          UnloadingName: null, // Разрузка груза: название порта
          UnloadingCode: null, // Разрузка груза: код порта
          VesselNationalityCode: null, // Код страны принадлежности судна
          VesselNationality: null, // Страна принадлежности судна
          RegNumBook: null, // Номер записи в книге учета перевозчика
          DocSig_PersonName: null, // Подпись документа: ФИО
          DocSig_IssueDate: null, // Подпись документа: дата
          DocSig_Phone: null, // Подпись документа: телефон
          Forwarder: null, // Наименование экспедитора
          FrDescription: null, // Примечание экспедитора
          FWDOCUMENT: {
            FWDOCUMENT_ITEM: [
              {
                DocumentName: null,
                DocumentNumber: null,
                DocumentDate: null
              }
            ]
          },
          ContractName: null,
          ContractNumber: null,
          ContractDate: null,
          DeliveryTermsStringCode: null, // Код условий поставки по Инкотермс
          DeliveryPlace: null, // Наименование пункта поставки
          TransferPlace: null, // Место передачи товара в соответствии с условиями договора (контракта)
          Reload: null, // Информация о перегрузке
          ACCOMPANYINGDOCUMENT: {
            ACCOMPANYINGDOCUMENT_ITEM: [
              {
                DocumentKind: null, // Тип документ
                DocumentName: null, // Наименование документа
                DocumentNumber: null, // Номер документа
                DocumentDate: null // Дата документа
              }
            ]
          },
          GoodsDescription: null
        },
        DocumentKindOptions: [
          { value: '1', text: 'Коносамент' },
          { value: '2', text: 'Копия коносамента' },
          { value: '3', text: 'Спецификация для погрузки' },
          { value: '4', text: 'Сертификат для погрузки' },
          { value: '5', text: 'Разрешение капитана на погрузку на судно' },
          { value: '6', text: 'Накладная для получателя' },
          { value: '7', text: 'Копия накладной для получателя' },
          { value: '8', text: 'Спецификация для получателя' },
          { value: '9', text: 'Сертификат для получателя' },
          { value: '10', text: 'Разрешение капитана на выгрузку с судна' },
          { value: '99', text: 'Иное' }
        ],
        portLang: 'port_eng',
        collapseCarrierVisible: false,
        collapseConsignorVisible: false,
        collapseConsigneeVisible: false,
        collapseNotifyVisible: false,
        collapseForwarderVisible: false,
        collapseContractVisible: false,
        collapseDeliveryVisible: false,
        collapseReloadVisible: false,
        collapseDocumentVisible: false
      }
    },
    watch: {
      commissionShipmentDoc (val) {
        if (val) {
          this.commissionForm = Object.assign(this.commissionForm, val.data)
          this.commissionForm.did = val.did
          for (let key in this.commissionForm) {
            if ((key === 'DocumentDate') ||
                (key === 'BorderCustomCode') ||
                (key === 'BorderCustomsOfficeName') ||
                (key === 'Carrier_CountryName') ||
                (key === 'Carrier_CountryCode') ||
                (key === 'Consignee_CountryName') ||
                (key === 'Consignee_CountryCode') ||
                (key === 'Notify_CountryName') ||
                (key === 'Notify_CountryCode') ||
                (key === 'LoadingName') ||
                (key === 'LoadingCode') ||
                (key === 'UnloadingName') ||
                (key === 'UnloadingCode') ||
                (key === 'VesselNationality') ||
                (key === 'VesselNationalityCode') ||
                (key === 'Consignor_CountryName') ||
                (key === 'Consignor_CountryCode') ||
                (key === 'FrDescription') ||
                (key === 'ContractDate') ||
                (key === 'DeliveryTermsStringCode') ||
                (key === 'Reload') ||
                (key === 'DocSig_IssueDate')) {
              this.$refs[key].model = this.commissionForm[key]
            }
            if (key === 'ACCOMPANYINGDOCUMENT') {
              const DocumentKind = this.DocumentKindOptions.find((item) => {
                return item.value === this.commissionForm[key]['ACCOMPANYINGDOCUMENT_ITEM'][0].DocumentKind
              })
              if (DocumentKind) {
                this.$refs['ACCOMPANYINGDOCUMENT_DocumentKind'].model = DocumentKind.text
                this.$refs['ACCOMPANYINGDOCUMENT_DocumentDate'].model = this.commissionForm[key]['ACCOMPANYINGDOCUMENT_ITEM'][0].DocumentDate
              }
            }
            if (key === 'FWDOCUMENT') {
              this.commissionForm[key]['FWDOCUMENT_ITEM'].map((item, index) => {
                this.$nextTick(() => {
                  this.$refs['DocumentDate-' + index][0].model = this.commissionForm[key]['FWDOCUMENT_ITEM'][index].DocumentDate
                })
              })
            }
          }
        }
      },
      'commissionForm.Carrier_INN' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Carrier_KPP' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Carrier_OGRN' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Carrier_PostalCode' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Carrier_Region' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Carrier_City' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Carrier_StreetHouse' (val) { if (val && (val.length > 0)) this.collapseCarrierVisible = true },
      'commissionForm.Consignor_INN' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignor_KPP' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignor_OGRN' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignor_PostalCode' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignor_Region' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignor_City' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignor_StreetHouse' (val) { if (val && (val.length > 0)) this.collapseConsignorVisible = true },
      'commissionForm.Consignee_INN' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Consignee_KPP' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Consignee_OGRN' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Consignee_PostalCode' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Consignee_Region' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Consignee_City' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Consignee_StreetHouse' (val) { if (val && (val.length > 0)) this.collapseConsigneeVisible = true },
      'commissionForm.Notify_INN' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Notify_KPP' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Notify_OGRN' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Notify_PostalCode' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Notify_Region' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Notify_City' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Notify_StreetHouse' (val) { if (val && (val.length > 0)) this.collapseNotifyVisible = true },
      'commissionForm.Forwarder' (val) { if (val && (val.length > 0)) this.collapseForwarderVisible = true },
      'commissionForm.FrDescription' (val) { if (val && (val.length > 0)) this.collapseForwarderVisible = true },
      'commissionForm.FWDOCUMENT': {
        handler (val) {
          if (val.FWDOCUMENT_ITEM.length > 0) {
            for (let i = 0; i < val.FWDOCUMENT_ITEM.length; i++) {
              if (val && (val.FWDOCUMENT_ITEM[i].DocumentDate && (val.FWDOCUMENT_ITEM[i].DocumentDate.length > 0))) this.collapseForwarderVisible = true
              if (val && (val.FWDOCUMENT_ITEM[i].DocumentName && (val.FWDOCUMENT_ITEM[i].DocumentName.length > 0))) this.collapseForwarderVisible = true
              if (val && (val.FWDOCUMENT_ITEM[i].DocumentNumber && (val.FWDOCUMENT_ITEM[i].DocumentNumber.length > 0))) this.collapseForwarderVisible = true
            }
          }
        },
        deep: true
      },
      'commissionForm.ContractName' (val) { if (val && (val.length > 0)) this.collapseContractVisible = true },
      'commissionForm.ContractNumber' (val) { if (val && (val.length > 0)) this.collapseContractVisible = true },
      'commissionForm.ContractDate' (val) { if (val && (val.length > 0)) this.collapseContractVisible = true },
      'commissionForm.DeliveryTermsStringCode' (val) { if (val && (val.length > 0)) this.collapseDeliveryVisible = true },
      'commissionForm.DeliveryPlace' (val) { if (val && (val.length > 0)) this.collapseDeliveryVisible = true },
      'commissionForm.TransferPlace' (val) { if (val && (val.length > 0)) this.collapseDeliveryVisible = true },
      'commissionForm.Reload' (val) { if (val && (val.length > 0)) this.collapseReloadVisible = true },
      'commissionForm.ACCOMPANYINGDOCUMENT': {
        handler (val) {
          if (val.ACCOMPANYINGDOCUMENT_ITEM.length > 0) {
            if (val && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentKind)) this.collapseDocumentVisible = true
          }
          if (val.ACCOMPANYINGDOCUMENT_ITEM.length > 0) {
            if (val && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentName && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentName.length > 0))) this.collapseDocumentVisible = true
          }
          if (val.ACCOMPANYINGDOCUMENT_ITEM.length > 0) {
            if (val && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentNumber && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentNumber.length > 0))) this.collapseDocumentVisible = true
          }
          if (val.ACCOMPANYINGDOCUMENT_ITEM.length > 0) {
            if (val && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentDate && (val.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentDate.length > 0))) this.collapseDocumentVisible = true
          }
        },
        deep: true
      }
    },
    computed: {
      ...mapState(
        {
          nsiCountries: state => state.commissionShipment.nsiCountries,
          nsiAuthorities: state => state.commissionShipment.nsiAuthorities,
          nsiPorts: state => state.commissionShipment.nsiPorts,
          nsiDeliveryCodes: state => state.commissionShipment.nsiDeliveryCodes
        }
      )
    },
    mounted () {
      this.$watch(
        () => { return this.$refs.LoadingCode.model },
        (val) => {
          if (val && val.match(/^[A-Za-z-`']+$/)) {
            this.portLang = 'port_eng'
          } else {
            this.portLang = 'port_rus'
          }
        }
      )
      this.$watch(
        () => { return this.$refs.LoadingName.model },
        (val) => {
          if (val && val.match(/^[A-Za-z-`']+$/)) {
            this.portLang = 'port_eng'
          } else {
            this.portLang = 'port_rus'
          }
        }
      )
      this.$watch(
        () => { return this.$refs.UnloadingName.model },
        (val) => {
          if (val && val.match(/^[A-Za-z-`']+$/)) {
            this.portLang = 'port_eng'
          } else {
            this.portLang = 'port_rus'
          }
        }
      )
      this.$watch(
        () => { return this.$refs.UnloadingCode.model },
        (val) => {
          if (val && val.match(/^[A-Za-z-`']+$/)) {
            this.portLang = 'port_eng'
          } else {
            this.portLang = 'port_rus'
          }
        }
      )
    },
    methods: {
      updateIdbData () {
        this.$emit('updateCommissionShipment')
      },
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      setModel (event) {
        if (('index' in event) && ('parent' in event) && (event.index !== null) && (event.parent !== null)) {
          if (event.parent === 'FWDOCUMENT_ITEM') {
            const name = event.fieldName.split('-')[0]
            this.commissionForm['FWDOCUMENT'][event.parent][event.index][name] = event.item
          } else {
            const name = event.fieldName.split('-')[0]
            this.commissionForm[event.parent][event.index][name] = event.item
          }
        } else {
          if (event.fieldName === 'ACCOMPANYINGDOCUMENT_DocumentDate') {
            this.commissionForm['ACCOMPANYINGDOCUMENT']['ACCOMPANYINGDOCUMENT_ITEM'][0].DocumentDate = event.item
          } else if (event.fieldName === 'ACCOMPANYINGDOCUMENT_DocumentKind') {
            this.commissionForm['ACCOMPANYINGDOCUMENT']['ACCOMPANYINGDOCUMENT_ITEM'][0].DocumentKind = (event.item && event.item.value) ? event.item.value : event.item
          } else {
            this.commissionForm[event.fieldName] = event.item
          }
        }
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      setRelated (event) {
        event.relatedFields.map((field) => {
          const key = Object.keys(field)[0]
          this.commissionForm[key] = event.item[field[key]]
          if (/^\d{4}-\d{2}-\d{2}$/.test(event.item[field[key]])) {
            let date = event.item[field[key]].split('-')
            date = date[2] + '.' + date[1] + '.' + date[0]
            this.$refs[key].model = date
          } else {
            this.$refs[key].model = event.item[field[key]]
          }
          return field
        })
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      async removePermissiveDocuments (index) {
        if (!(this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.length === 1)) {
          this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.splice(index, 1)
        }
        await this.updateIdbData()
      },
      addPermissiveDocuments () {
        this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.push(
          {
            DocumentName: null,
            DocumentNumber: null,
            DocumentDate: null
          }
        )
      },
      resetFormData () {
        const props = Object.getOwnPropertyNames(this.commissionForm)
        for (let i = 0; i < props.length; i++) {
          if (props[i] === 'FWDOCUMENT') {
            const CSFWDocLn = this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.length
            this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM.splice(1, (CSFWDocLn - 1))
            this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM[0].DocumentName = null
            this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM[0].DocumentNumber = null
            this.commissionForm.FWDOCUMENT.FWDOCUMENT_ITEM[0].DocumentDate = null
            setTimeout(() => {
              this.$refs['DocumentDate-0'][0].model = null
            }, 0)
          } else if (props[i] === 'ACCOMPANYINGDOCUMENT') {
            const CSADocLn = this.commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM.length
            this.commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM.splice(1, (CSADocLn - 1))
            this.commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentKind = null
            this.commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentName = null
            this.commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentNumber = null
            this.commissionForm.ACCOMPANYINGDOCUMENT.ACCOMPANYINGDOCUMENT_ITEM[0].DocumentDate = null
            this.$refs['ACCOMPANYINGDOCUMENT_DocumentKind'].model = null
            this.$refs['ACCOMPANYINGDOCUMENT_DocumentDate'].model = null
          } else {
            this.commissionForm[props[i]] = null
            if (this.$refs[props[i]]) {
              this.$refs[props[i]].model = null
            }
          }
        }
      },
      ...mapActions({
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        loadNsiAuthorities: 'commissionShipment/loadNsiAuthorities',
        loadNsiPorts: 'commissionShipment/loadNsiPorts',
        loadNsiDeliveryCodes: 'commissionShipment/loadNsiDeliveryCodes'
      }),
    }
  }
</script>

<style lang="scss" scoped>
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  #FrDescription, #Reload {
    border-radius: 0 !important;
  }
  #DocumentKind {
    border-radius: 0 !important;
  }
  .form-title-forwarder {
    color: #38455d;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 5px;
  }
</style>
